<script lang="ts">
  import BaseStep from "./BaseStep.svelte";
  import SharedHeading from "../SharedHeading.svelte";
  import { getCopy } from "../../lib/stores/copy";
  import Button from "../Button.svelte";
  import { DefaultAuthFlow } from "../../lib/helpers/auth/DefaultAuthFlow";
  import { sessionStore, updateSession } from "../../lib/stores/session";
  import Activision from "../../assets/icons/activision.svg";
  import { onMount } from "svelte";
  import { getSearchParam } from "../../lib/helpers/document";
  import LoadingScreen from "../LoadingScreen.svelte";
  import { settingsStore } from "../../lib/stores/settings";
  import { getCampaign } from "../../lib/apiLoader/campaign";
  import { getUnixTimeMinuteGranularity } from "../../lib/utils";
  import { getCampaignPeriod } from "../../lib/public/lib/helpers/authData";

  export let currentRoute;

  let isBusy: boolean;
  let isFinishingAuth = false;

  const onAuth = async () => {
    try {
      isBusy = true;
      updateSession({ isAuthenticating: true });

      // Casting because campaign must exist at this point
      const campaignKey: string = $settingsStore.campaign as string;

      const { result: campaign } = await getCampaign(campaignKey, getUnixTimeMinuteGranularity());
      const period = getCampaignPeriod(campaign);

      await new DefaultAuthFlow().start({
        channel: "callofduty",
        foojiData: {
          period,
          organization_id: campaign.organization_id,
          workflow_key: campaignKey
        }
      });
    } catch (e) {
      console.error("Error starting COD auth flow", e);
      $sessionStore.isAuthenticating = false;
      isBusy = false;
    }
  };

  onMount(() => {
    isBusy = false;
    isFinishingAuth = !!getSearchParam("jwt");
    $sessionStore.isAuthenticating = false;
  });

  $: isAuthenticating = $sessionStore.isAuthenticating;
  // FIXME: separate this copy from the secondary channel auth copy
  $: copy = $getCopy("secondaryChannelAuth") as Record<string, string>;
</script>

<BaseStep {currentRoute}>
  <svelte:fragment slot="content">
    {#if isFinishingAuth}
      <LoadingScreen />
    {:else}
      <SharedHeading headerCopy={copy.headerCopy} subHeaderCopy={copy.subHeaderCopy} />
      <div class="flex w-full flex-col items-center mt-8 gap-8">
        <Button
          class="lg:w-72"
          primary
          disabled={isAuthenticating}
          {isBusy}
          on:click={onAuth}>
          <img src={Activision} class="w-6" alt={"callofduty"} slot="icon" />
          {copy.callOfDutyStartButtonCopy}
        </Button>
      </div>
    {/if}
  </svelte:fragment>
</BaseStep>
